import { render, staticRenderFns } from "./DashboardStudentObservations.vue?vue&type=template&id=06bd9e7c&scoped=true&"
import script from "./DashboardStudentObservations.vue?vue&type=script&lang=js&"
export * from "./DashboardStudentObservations.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStudentObservations.vue?vue&type=style&index=0&id=06bd9e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd9e7c",
  null
  
)

export default component.exports